<template>
  <div class="map-container">
    <l-map :center="center" class="map-component" ref="mainMap" :zoom="zoom">
      <l-tile-layer :attribution="attribution" :url="url"></l-tile-layer>
      <l-marker :key="marker.id" :lat-lng="marker.latLng"
                @click="$router.push({name: 'unit', params: {id: marker.id}})"
                v-for="marker in markers"></l-marker>
    </l-map>
  </div>
</template>

<script>
import { LMap, LMarker, LTileLayer } from 'vue2-leaflet';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon.png'),
  iconUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: 'Map',
  mounted() {
    this.$nextTick(() => {
      if (this.markers.length > 1) {
        if (this.$refs.mainMap.mapObject !== undefined) {
          this.$refs.mainMap.mapObject.fitBounds(this.bounds);
        }
      } else {
        this.zoom = 11;
      }
    });
  },
  props: {
    bounds: {
      type: Array,
      required: false,
      default() {
        return [
          [40.712, -74.227],
          [40.774, -74.125],
        ];
      },
    },
    salons: {
      type: Array,
      required: false,
    },
    center: {
      type: Object,
      required: false,
      default() {
        return {
          lat: 51.5509,
          lng: 19.08,
        };
      },
    },
    zoom:
        {
          type: Number,
          required: false,
        },
  },
  components: {
    LMap, LTileLayer, LMarker,
  },
  data() {
    return {
      // center: L.latLng(0,0),
      url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
      // latlng: L.latLng(this.salon.longitude, this.salon.latitude),
      icon: L.icon({
        iconUrl: '@/assets/images/localization/marker.png',
        shadowUrl: 'leaflet/dist/images/marker-shadow.png',

        iconSize: [59, 59],
        shadowSize: [50, 64],
        iconAnchor: [26, 58],
        shadowAnchor: [22, 49],

      }),
    };
  },
  computed: {
    markers() {
      const { salons } = this;
      salons.forEach((v) => {
        v.latLng = L.latLng(v.latitude, v.longitude);
      });
      return salons;
    },
  },
};
</script>

<style scoped>

</style>
